import { DetailedHTMLProps, HTMLAttributes } from 'react';
import Icon, { IconVariant } from 'src/components/ui-kit/icon/icon';
import styles from './section.module.scss';

export default function ContactSection({
  text,
  iconVariant,
  children
}: {
  text: string;
  iconVariant: IconVariant;
} & DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>): JSX.Element {
  return (
    <>
      <h4 className={styles.section}>
        <span className={styles.section_icon}>
          <Icon variant={iconVariant} />
        </span>
        {text}
      </h4>
      {children}
    </>
  );
}
